import {
	FormControlLabel,
	FormLabel,
	Grid,
	InputLabel,
	MenuItem,
	Radio,
	RadioGroup,
	Select,
	TextField,
} from "@material-ui/core";
import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import BottomFloat2 from "../components/containers/BottomFloat2";

import RetailerAccountTemplate from "../components/RetailerAccountTemplate";
import { setDepositWithdrawals } from "../redux/items/DepositWithdrawal";
import { parseInt2, MonthsLong } from "../utils/functions";
import PayNowAutoCredit from "../components/PayNowAutoCredit";
import FetchLogin from "../components/Fetch/FetchLogin";
import { setLoadingPage } from "../redux/items/PageLoading";

const Deposit = () => {
	const token = useSelector((state) => state.login.token);
	const set = useSelector((state) => state.drawSet.set);

	const depositType = useSelector(
		(state) => state.DepositWithdrawal.deposit.type
	);

	const dispatch = useDispatch();

	const [v, setV] = useState({
		d: new Date(),
		amount: "",
		card_number: "",
		exp_year: "",
		exp_month: "",
		cvc: "",
		success: true,
		error: "",
	});

	const setV2 = (v2) => {
		setV((prev) => ({ ...prev, ...v2 }));
	};

	const reqDeposit = FetchLogin("deposit-card", {
		data: {
			token: token,
			amount: v.amount,
			card_number: v.card_number,
			exp_month: v.exp_month + 1,
			exp_year: v.exp_year,
			cvc: v.cvc,
		},
		callbackInit: () => {
			setV2({ success: true, error: "" });
			dispatch(setLoadingPage(true));
		},
		callback: (cb) => {
			if (cb.response.success) {
				if (cb.response.data?.redirect) {
					setTimeout(() => {
						// window.open(cb.response.data.redirect, "_blank");
						window.location.href = cb.response.data.redirect;
					}, 0);
				}

				setV2({
					success: cb.response.success,
					error: cb.response.message,
					amount: "",
					card_number: "",
					exp_year: v.d.getFullYear(),
					exp_month: v.d.getMonth(),
					cvc: "",
				});
			} else {
				setV2({ success: cb.response.success, error: cb.response.message });
			}
			dispatch(setLoadingPage(false));
		},
	});

	return (
		<RetailerAccountTemplate title="Deposit">
			<div
				style={{
					display: "flex",
					flexDirection: "column",
					fontSize: 18,
					width: "90%",
				}}
			>
				<div
					className="select-deposit-method-wrapper"
					style={{
						display: "flex",
						flexDirection: "row",
						alignItems: "center",
						justifyContent: "space-between",
						margin: "0 auto",
					}}
				>
					<div style={{ fontSize: 20 }}>
						Deposit Method
						{/* {v.timer} */}
					</div>
					<RadioGroup
						aria-labelledby="deposit_method"
						defaultValue="paynow"
						name="deposit_method"
						value={depositType}
						onChange={(e) => {
							dispatch(setDepositWithdrawals("deposit.type", e.target.value));
						}}
					>
						<FormControlLabel
							value="paynow"
							control={<Radio />}
							label="PayNow"
						/>
						<FormControlLabel
							value="card"
							control={<Radio />}
							label="Card Payment"
						/>
						<FormControlLabel
							value="fund-transfer"
							control={<Radio />}
							label="Fund Transfer"
						/>
					</RadioGroup>
				</div>
				<div
					style={{
						display: depositType === "paynow" ? "flex" : "none",
						flexDirection: "column",
					}}
				>
					<h2 style={{ margin: "0 auto", marginTop: 20 }}>Pay Now</h2>

					{set?.enable_deposit_paynow ? (
						<PayNowAutoCredit />
					) : (
						<p style={{ color: "red", margin: "0 auto", marginTop: 20 }}>
							Currently Unavailable
						</p>
					)}
				</div>

				<div
					style={{
						display: depositType === "card" ? "flex" : "none",
						flexDirection: "column",
						marginTop: 20,
					}}
				>
					<h2 style={{ margin: "0 auto", marginTop: 20 }}>Card Payment</h2>

					{set?.enable_deposit_card ? (
						<>
							<Grid
								container
								style={{
									marginTop: 20,
								}}
							>
								<Grid
									item
									container
									xs={5}
									style={{
										justifyContent: "flex-start",
										alignItems: "center",
									}}
								>
									<InputLabel
										htmlFor="deposit-amount"
										style={{
											fontSize: 18,
											display: "flex",
										}}
									>
										Deposit Amount
									</InputLabel>
								</Grid>
								<Grid item xs={7}>
									<div style={{ display: "flex", flexDirection: "row" }}>
										<span
											style={{
												border: "1px solid #ccc",
												padding: "0 20px",
												display: "flex",
												alignItems: "center",
												color: "#333",
											}}
										>
											SGD
										</span>
										<TextField
											id="deposit-amount"
											aria-describedby="deposit-amount"
											placeholder=""
											className="left-label"
											value={v.amount === 0 ? "" : v.amount}
											onChange={(e) =>
												setV2({ amount: parseInt2(e.target.value, "") })
											}
											variant="outlined"
										/>
									</div>
									<i style={{ color: "#aaa" }}>minimum of 10</i>
								</Grid>
							</Grid>

							<div
								style={{
									flexDirection: "column",
								}}
							>
								<h2>Card Details</h2>
								<Grid
									container
									style={{
										justifyContent: "center",
										alignItems: "space-between",
										height: 300,
									}}
								>
									<Grid item xs={12}>
										<FormLabel>Card Number</FormLabel>
										<TextField
											fullWidth={true}
											value={v.card_number}
											onChange={(e) => setV2({ card_number: e.target.value })}
											type="number"
											variant="outlined"
										/>
									</Grid>
									<Grid item xs={5}>
										<FormLabel>Expiration Year</FormLabel>
										<Select
											value={v.exp_year}
											onChange={(e) => setV2({ exp_year: e.target.value })}
										>
											{[...Array(10)].map((a, aI) => {
												let d1 = v.d.getFullYear() + aI;
												return (
													<MenuItem value={d1} key={aI}>
														{d1}
													</MenuItem>
												);
											})}
										</Select>
									</Grid>
									<Grid item xs={2}></Grid>
									<Grid item xs={5}>
										<FormLabel>Expiration Month</FormLabel>
										<Select
											value={v.exp_month}
											onChange={(e) => setV2({ exp_month: e.target.value })}
										>
											{MonthsLong.map((a, aI) => {
												return (
													<MenuItem value={aI} key={aI}>
														{a}
													</MenuItem>
												);
											})}
										</Select>
									</Grid>
									<Grid item xs={6}>
										<FormLabel>CVC</FormLabel>
										<TextField
											value={v.cvc}
											onChange={(e) => setV2({ cvc: e.target.value })}
											type="number"
											variant="outlined"
										/>
									</Grid>
								</Grid>
								<p
									dangerouslySetInnerHTML={{ __html: v.error }}
									style={{
										color: v.success ? "green" : "red",
										textAlign: "center",
									}}
								/>
							</div>
						</>
					) : (
						<p
							style={{
								color: "red",
								justifyContent: "center",
								display: "flex",
							}}
						>
							Currently Unavailable
						</p>
					)}
				</div>

				<div
					style={{
						display: depositType === "fund-transfer" ? "flex" : "none",
						flexDirection: "column",
					}}
				>
					<h2 style={{ margin: "0 auto", marginTop: 20 }}>Fund Transfer</h2>

					{set?.enable_deposit_fund_transfer ? (
						<ol style={{ marginTop: 20 }}>
							<li>First time, or having trouble purchasing?</li>
							<li>
								Reach out to support team by WhatsApp/SMS to{" "}
								<a
									href="https://sgpoolsretailer.com/support"
									target="_blank"
									rel="noreferrer"
								>
									https://sgpoolsretailer.com/support
								</a>
							</li>
						</ol>
					) : (
						<p style={{ color: "red", margin: "0 auto", marginTop: 20 }}>
							Currently Unavailable
						</p>
					)}
				</div>
			</div>

			<BottomFloat2
				moneyTitle="Deposit Amount"
				title="Submit"
				total={parseInt2(v.amount)}
				onClick={() => reqDeposit.handleTrigger()}
				style={{
					display: depositType === "card" ? "flex" : "none",
				}}
			/>
		</RetailerAccountTemplate>
	);
};

export default Deposit;
